var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
export class DisplayRecoveryState {
    constructor() {
        this.displaysecret = "";
        this.displaymastersecret = "";
        this.basediaglogstate = new BaseDialogState();
        makeObservable(this);
        this.basediaglogstate.setHeaderLabel("Recovery Key");
        this.basediaglogstate.setHideCancelButton(true);
        this.basediaglogstate.setHideCloseButton(true);
        this.basediaglogstate.setOkLabel("Save and Close");
        this.basediaglogstate.onOk = () => {
            this.downloadAndCloseDialog();
        };
        APPEvent.addSubscriberForShowSecretDialog((sec) => {
            if (sec.useraction) {
                return;
            }
            this.setDisplaySecret(sec.secret);
            this.basediaglogstate.setOpen(true);
        });
    }
    downloadAndCloseDialog() {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.displaysecret));
        element.setAttribute('download', "letrwing_recoverycode.txt");
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        Apphandler.sendMessage("recoverycodedownloaded", "");
        this.basediaglogstate.setOpen(false);
    }
    setDisplaySecret(secret) {
        this.displaysecret = secret;
    }
    setDisplayMasterSecret(msec) {
        this.displaymastersecret = msec;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DisplayRecoveryState.prototype, "displaysecret", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DisplayRecoveryState.prototype, "displaymastersecret", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DisplayRecoveryState.prototype, "setDisplaySecret", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DisplayRecoveryState.prototype, "setDisplayMasterSecret", null);
